import http from '@root/utils/axios/admin';

let state = {
    ReceiptAddressesList: [],
    ReceiptAddress: {
        data: {},
        error: {}
    }
}

let actions = {

    fetchReceiptAddressesList({ commit }, filter = {}) {
        return new Promise((resolve, reject) => {
            http.get('/api/receipt-addresses', { params: filter }).then((response) => {
                commit('setReceiptAddresses', response.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },

    deleteReceiptAddress({ commit }, id) {
        return http.delete('/api/receipt-addresses/' + id);
    },

    fetchReceiptAddress({ commit }, id) {
        return new Promise((resolve, reject) => {
            http.get('/api/receipt-addresses/' + id).then((response) => {
                commit('setReceiptAddress', response.data.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },

    CreateReceiptAddress({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('/api/receipt-addresses', data).then((response) => {
                commit('setReceiptAddress', response.data);
                resolve(response);
            }).catch((error) => {
                if (error.response && error.response.status === 422) {
                    commit('setReceiptAddressError', error.response.data);
                }
                reject(error.response);
            })
        });

    },

    updateReceiptAddress({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('/api/receipt-addresses/' + data.get('id'), data).then((response) => {
                commit('setReceiptAddress', response.data);
                resolve(response);
            }).catch((error) => {
                if (error.response && error.response.status === 422) {
                    commit('setReceiptAddressError', error.response.data);
                }
                reject(error.response);
            })
        });
    },



}


let mutations = {
    setReceiptAddresses(state, data) {
        state.ReceiptAddressesList = data;
    },
    setReceiptAddress(state, data) {
        state.ReceiptAddress.data = data;
    },
    setReceiptAddressError(state, error) {

        state.ReceiptAddress.error = error.errors;
    },
    cleanReceiptAddressError(state, error) {
        state.ReceiptAddress.error = {};
    },

}

export default {
    state,
    actions,
    mutations
}